import {ReactNode} from "react";
import {DibJsonNode} from "../../types";
import contentLinkClasses from "../contentLink.module.css";
import classes from "./externalLink.module.css";

export const ExternalLink = ({
    node,
    children,
}: {
    node: DibJsonNode;
    children: ReactNode[];
}) => {
    const href =
        node.object?.type === "linkdata" ? node.object.data.href : "#";

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`${contentLinkClasses.navLink} ${classes.externalIcon}`}
        >
            {children}
        </a>
    );
};
